import * as React from "react";
import { Grid, Link } from "@mui/material";
import { DataGridPremium, GridColDef } from "@mui/x-data-grid-premium";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import CclDataGridToolbar from "../../../components/common/cclDataGridToolbar/cclDataGridToolbar";
import { miscWorkRecords } from "./miscWorkData";

function getDateFromTimestamp(date: string) {
    if (!date) {
        return "";
    }
    return new Date(date).toLocaleDateString();
}

function getCurrency(value: number) {
    return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

const MiscWorkPanel: React.FC = () => {
    const [selectedRows, setSelectedRows] = React.useState<Array<string | number>>([]);
    const navigate = useNavigate();

    const openDetails = (id: string | number) => {
        navigate(`/misc-work-details/${id}`);
    };

    const handleToolbarButtonClick = (btnId: string) => {
        if (btnId !== "view-misc-work-details" || selectedRows.length !== 1) {
            return;
        }

        openDetails(selectedRows[0]);
    };

    const columns: GridColDef[] = [
        {
            field: "projectCode",
            headerName: "Project ID",
            width: 140,
            renderCell: (params) => (
                <Link
                    component={RouterLink}
                    to={`/misc-work-details/${params.row.id}`}
                    onClick={(event) => event.stopPropagation()}
                >
                    {params.value}
                </Link>
            ),
        },
        { field: "projectName", headerName: "Project Name", width: 240 },
        { field: "trainerName", headerName: "Trainer", width: 180 },
        { field: "workType", headerName: "Work Type", width: 190 },
        { field: "status", headerName: "Status", width: 130 },
        { field: "client", headerName: "Client", width: 180 },
        {
            field: "workDate",
            headerName: "Work Date",
            valueGetter: (params) => getDateFromTimestamp(params.row.workDate),
            width: 140,
        },
        { field: "totalHours", headerName: "Hours", type: "number", width: 100 },
        {
            field: "totalAmount",
            headerName: "Amount",
            valueGetter: (params) => getCurrency(params.row.totalAmount),
            width: 130,
        },
    ];

    return (
        <Grid container spacing={0} alignItems="stretch" sx={{ justify: "space-between", flexGrow: 1 }}>
            <Grid
                item
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: 1,
                    height: "calc(100vh - 220px)",
                    minHeight: 400,
                }}
            >
                <DataGridPremium
                    columns={columns}
                    rows={miscWorkRecords}
                    getRowId={(row) => row.id}
                    components={{ Toolbar: CclDataGridToolbar }}
                    componentsProps={{
                        toolbar: {
                            showSaveState: false,
                            hideSettingsButtons: true,
                            savestate: null,
                            clearstate: null,
                            anySelected: selectedRows.length === 1,
                            miscButtons: [
                                {
                                    id: "view-misc-work-details",
                                    caption: "View Details",
                                    onClick: null,
                                    returnSelected: false,
                                    restricted: false,
                                    disable: selectedRows.length !== 1,
                                },
                            ],
                            btnClick: handleToolbarButtonClick,
                        },
                    }}
                    checkboxSelection
                    disableSelectionOnClick
                    onSelectionModelChange={(newSelection: any) =>
                        setSelectedRows(newSelection as Array<string | number>)
                    }
                    onRowDoubleClick={(params) => openDetails(params.id)}
                />
            </Grid>
        </Grid>
    );
};

export default MiscWorkPanel;